module.exports = __webpack_public_path__ + "6c4a0dbc/img/verified-icon.f93bbc14.svg";